<template>
  <div>
    <b-row>
      <b-col>
        <form-base-side-bar
          title="Enter new user system details"
          :submit-status="submitStatus"
          action="Create"
          :errors="errors"
          :loading="loading"
          v-on:handleSubmit="handleSubmit"
        >
          <template v-slot:fields>
            <label class="form-group has-float-label mb-4">
              <input
                ref="name"
                type="text"
                @blur="$v.user.name.$touch"
                class="form-control"
                :class="{ 'is-invalid': $v.user.name.$error }"
                v-model="user.name"
              />
              <span>Full Name</span>
              <div class="invalid-feedback" v-if="!$v.user.name.required">Please enter full name</div>
            </label>

            <label class="form-group has-float-label mb-4">
              <input
                type="email"
                class="form-control"
                :class="{ 'is-invalid': $v.user.email.$error }"
                v-model="user.email"
              />
              <span>Email</span>
              <div
                class="invalid-feedback"
                v-if="!$v.user.email.required"
              >Please enter email address</div>
              <div class="invalid-feedback" v-if="!$v.user.email.email">invalid email address</div>
            </label>

            <label class="form-group has-float-label mb-4">
              <input
                type="password"
                class="form-control"
                :class="{ 'is-invalid': $v.user.password.$error }"
                v-model="user.password"
              />
              <span>Password</span>
              <div
                class="invalid-feedback"
                v-if="!$v.user.password.minLength"
              >Please enter password with a minimun of 6 characters</div>
            </label>

            <div class="form-group">
              <label class="form-label">Please select users roles</label>
              <span v-for="item in roles" :key="item.id">
                <b-form-checkbox v-model="user.roles" :value="item.id">
                  <span class="text-body">{{ item.name }}</span>
                </b-form-checkbox>
              </span>
              <div class="text-danger" v-if="$v.user.roles.$error">Please select permissions</div>
            </div>

        
          </template>
        </form-base-side-bar>
      </b-col>
    </b-row>

    <div class="row">
      <div class="col">
        <hr />
        <h5>Role Definitions:</h5>
        <span v-for="role in roles" :key="role.id">
          <p class="text-muted text-small mb-3 font-weight-bold">{{ role.name }}'s can:</p>
          <ul class="list-unstyled mb-4">
            <li
              class="nav-item"
              v-for="permission in role.permissions"
              :key="permission.id"
            >
              - {{ permission.name }}
            </li>
          </ul>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import userRepo from "@/api/repos/userRepo";
import { required, email, minLength } from "vuelidate/lib/validators";
import formBaseSideBar from "@/components/common/FormBaseSideBar";
import roleRepo from "@/api/repos/roleRepo";

export default {
  components: {
    formBaseSideBar,

  },
  computed: {
   
  },

  mounted() {
    this.$refs.name.focus()
    this.getRoles();
  },

  validations: {
    user: {
      name: {
        required
      },
      email: {
        required,
        email
      },
      password: {
        required,
        minLength: minLength(6)
      },
      roles: {
        required
      }
    }
  },

  data() {
    return {
      user: { image_id: null },
      roles: [],
      loading: false,
      errors: [],
      submitStatus: null,
      imageUploading: false
    };
  },

  methods: {
    async getRoles() {
      try {
        let { data } = await roleRepo.roles(1,1000,'name','asc','');
        this.roles = data.roles.data;
      } catch (error) {
        console.log(error);
      }
    },
    async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";
      this.$v.$touch();
      if (this.$v.$invalid || this.imageUploading) {
        if (this.imageUploading) alert("images uploading...");
        this.submitStatus = "ERROR";
        this.loading = false;
      } else {
        try {
          await userRepo.create(this.user);
          this.$emit("userCreated");
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            console.log(this.errors);
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    }
  }
};
</script>

<style></style>
